import "core-js/modules/es.array.map.js";
import React from 'react';
import RequirementAttachment from "../Components/RequirementAttachment";
import { getCorrectURL } from "../../../../../util/isAbsolutePath";
var RequirementAttachments = function RequirementAttachments(_ref) {
  var attachments = _ref.attachments,
    verifiedDocument = _ref.verifiedDocument,
    applyproofVerified = _ref.applyproofVerified;
  if (!applyproofVerified) {
    return attachments.map(function (attachment) {
      return attachment.attributes.status !== 'disapproved' ? /*#__PURE__*/React.createElement(RequirementAttachment, {
        fileName: attachment.attributes.file_name,
        key: attachment.id,
        link: attachment.attributes.file_download_link
      }) : null;
    });
  }
  if (verifiedDocument && verifiedDocument.attributes) {
    return /*#__PURE__*/React.createElement(RequirementAttachment, {
      fileName: "".concat(verifiedDocument.attributes.filename, ".pdf"),
      link: getCorrectURL(verifiedDocument.attributes.verifiedDocument.url)
    });
  }
  return null;
};
export default RequirementAttachments;